





















































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import TopNavigationComponent from '../navigation/TopNavigationComponent.vue';

@Component({
  components: {
    TopNavigationComponent
  }
})
export default class PrivacyPolicyComponent extends Vue {
  private created () {
    this.$emit('policy', 'privacypolicy');
  }

  public async goback () {
    this.$router.go(-1);
  }
}
